"use strict";

var Constants = require('./constants');
var Gallery = require('ofs/react/components/gallery/gallery');

var BaseActions = {
  resize: function(event) {
    this.dispatch(Constants.RESIZED, {event});
  },

  scroll: function(event) {
    this.dispatch(Constants.SCROLLED, {event});
  },

  click: function(event) {
    this.dispatch(Constants.CLICKED, {event});
  },

  // React-form Changes
  formFieldChange: function(name, value, context) {
    this.dispatch(Constants.FORM_FIELD_CHANGED, {name, value, context});
  },

  updateCityData: function(data) {
    this.dispatch(Constants.CITY_UPDATE, {data});
  },

  updatePriceData: function(data) {
    this.dispatch(Constants.PRICE_UPDATE, {data});
  },

  changeActiveFieldset: function(index, context) {
    this.dispatch(Constants.CHANGE_ACTIVE_FIELDSET, {index, context});
  },

  changeContextCity: function(cityCode) {
    this.dispatch(Constants.CHANGE_CONTEXT_CITY, {cityCode});
  },

  changeBudget: function(budgetMax) {
    this.dispatch(Constants.CHANGE_GUEST_BUDGET, budgetMax);
  },

  onboarding: {
    introduction: {
      formSubmit: function(payload) {
        this.dispatch(Constants.FORM_SUBMIT, payload);
      },
      resetRequestError: function() {
        this.dispatch(Constants.RESET_REQUEST_ERROR);
      }
    }
  },

  quote: {
    update: function(data) {
      this.dispatch(Constants.BOOKING_QUOTE_UPDATE, {data});
    },

    error: function(response) {
      var data = JSON.parse(response.responseText);
      this.dispatch(Constants.BOOKING_QUOTE_ERROR, {data});
    }
  },

  // Availability Calendar
  calendar: {
    completeRangeSelection: function(range, states) {
      this.dispatch(Constants.COMPLETE_CALENDAR_RANGE_SELECTION, {range, states});
      this.dispatch(Constants.CHANGE_PAGE_DATE_RANGE, {range});
    },

    legacyCompleteRangeSelection: function(range) {
      this.dispatch(Constants.CHANGE_PAGE_DATE_RANGE, {range});
    }

  },

  guest: {
    updateGuestNumber: function(numberOfGuests) {
      this.dispatch(Constants.CHANGE_GUEST_NUMBER, numberOfGuests);
    }
  },

  // Rooms Widget
  rooms: {
    changeActive: function(index_, context) {
      var index = parseInt(index_, 10);
      this.dispatch(Constants.CHANGE_ACTIVE_ROOM, {index, context});
    }
  },

  // Media Organiser
  mediaOrganiser: {
    changeActive: function(uuid) {
      this.dispatch(Constants.CHANGE_ACTIVE_CONTAINER, {uuid});
    },
    selectMedia: function(mediaID) {
      this.dispatch(Constants.SELECT_MEDIA, {mediaID});
    },
    unselectMedia: function(mediaID) {
      this.dispatch(Constants.UNSELECT_MEDIA, {mediaID});
    },
    assignMedia: function(container, media) {
      this.dispatch(Constants.ASSIGN_MEDIA, {container, media});
    },
    unAssignMedia: function(container, media) {
      this.dispatch(Constants.UNASSIGN_MEDIA, {container, media});
    },
    dragMediaStart: function(media, x, y) {
      this.dispatch(Constants.DRAG_MEDIA_START, {media, x, y});
    },
    dragMediaOver: function(media, x, y) {
      this.dispatch(Constants.DRAG_MEDIA_OVER, {media, x, y});
    },
    dragMediaEnd: function(media) {
      this.dispatch(Constants.DRAG_MEDIA_END, {media});
    }
  },

  // Modal
  modal: {
    open: function(renderFunction) {
      this.dispatch(Constants.OPEN_MODAL, {renderFunction});
    },

    close: function() {
      this.dispatch(Constants.CLOSE_MODAL, {});
    }
  },

  layers: {
    addModal: function(component, modalStyle) {
      this.dispatch(Constants.ADD_MODAL, {component, modalStyle});
    },

    addPopover: function(component) {
      this.dispatch(Constants.ADD_POPOVER, {component});
    },

    addTooltip: function(component) {
      this.dispatch(Constants.ADD_TOOLTIP, {component});
    },

    remove: function(component) {
      this.dispatch(Constants.REMOVE_LAYER, {component});
    }
  },

  tracking: {
    sendEnquiryEvent: function(payload) {
      this.dispatch(Constants.PUSH_ENQUIRY_EVENT, payload);
    },
    sendGenericEvent: function(payload) {
      this.dispatch(Constants.PUSH_GENERIC_EVENT, payload);
    },
    trackFormSubmit: function(label) {
      this.dispatch(Constants.PUSH_FORM_SUBMIT, label);
    }
  },

  // Image Gallery
  gallery: {
    open: function(image) {
      this.dispatch(Constants.CHANGE_ACTIVE_GALLERY_IMAGE, {image});
      this.dispatch(Constants.ADD_LAYER, {component: Gallery, isModal: true});
    },

    changeActive: function(index_, context) {
      var index = parseInt(index_, 10);
      this.dispatch(Constants.CHANGE_ACTIVE_GALLERY_IMAGE, {index, context});
    },

    showHeader: function() {
      this.dispatch(Constants.SHOW_GALLERY_HEADER, {});
    },

    hideHeader: function() {
      this.dispatch(Constants.HIDE_GALLERY_HEADER, {});
    }
  },

  // Similar Homes
  similarHomes: {
    load: function() {
      this.dispatch(Constants.SIMILAR_HOMES_LOAD, {});
    },

    update: function(json) {
      this.dispatch(Constants.SIMILAR_HOMES_UPDATE, {json});
    }
  },

  // Text Truncator Componets
  expandText: function(data) {
    this.dispatch(Constants.TEXT_EXPANDED, {data});
  },

  contentModules: {
    addModule: function(layout, index) {
      this.dispatch(Constants.CONTENT_MODULE_ADD, {layout, index});
    },

    removeModule: function(index) {
      this.dispatch(Constants.CONTENT_MODULE_REMOVE, {index});
    },

    replaceModules: function(modules) {
      this.dispatch(Constants.CONTENT_MODULES_REPLACE, {modules});
    },

    changeValue: function(index, name, value) {
      this.dispatch(Constants.CONTENT_MODULE_CHANGE_VALUE, {index, name, value});
    }
  },

  language: {
    acceptLanguageWarning: function() {
      this.dispatch(Constants.ACCEPT_LANGUAGE_WARNING, {});
    },
    setLanguage: function(lang) {
      this.dispatch(Constants.SET_LANGUAGE, {lang});
    }
  },

  // use odd name because `scroll` already exists
  scrollManager: {
    to: function(payload) {
      this.dispatch(Constants.SCROLL_TO, payload);
    }
  }
};

module.exports = BaseActions;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/core/base-actions.js
 **/